module.exports = "/assets/982330333dab508ed891e6a492ffeb7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/GA.png
// module id = 2523
// module chunks = 0